import { Factory } from '../../services/Factory';


export interface IExportInfoScope extends angular.IScope {
  exportObj: any;
  native: boolean;
}

export interface IExportInfoAttributes extends angular.IAttributes {
}

export class ExportInfo implements angular.IDirective {
  public restrict:string = 'E';
  public templateUrl:string;

  public scope = { exportObj: '=ngModel', native: '=' };
  public require = ['ngModel'];

  constructor() {
    this.templateUrl = "partials/exporting/export_info.html";
  }
}

frontendApp.directive("iioExportInfo", [Factory.Create(ExportInfo)]);
